import { render, staticRenderFns } from "./encyclopedia.vue?vue&type=template&id=114c9ad9&"
import script from "./encyclopedia.vue?vue&type=script&lang=js&"
export * from "./encyclopedia.vue?vue&type=script&lang=js&"
import style0 from "./encyclopedia.vue?vue&type=style&index=0&id=114c9ad9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports